import React from 'react'

import Nav from '@components/layout/Nav'
import NavLogo from '@atoms/NavLogo'
import NavFeatures from '@components/layout/Nav/NavFeatures'
import HideHeader from '@particles/hideHeader'
import './header.scss'

const Header = ({ location, visible }) => {
	const navbarStyles = {
		textAlign: 'center',
		transition: 'top 0.6s'
	}
	return (
		<>
			<aside
				id="o__header"
				style={{ ...navbarStyles, top: visible ? '0' : '-200px' }}
			>
				<NavLogo />
				<Nav location={location} />
				<NavFeatures />
			</aside>
		</>
	)
}
export default HideHeader(Header)
